import { fetch } from '@/common/request';

// Skill-Tool 绑定（仅支持 MCP Tools）
export interface SkillToolBindingVo {
  id: number;
  skillId: number;
  skillName?: string;
  toolCode: string;
  toolId?: number;
  toolSource: 'mcp'; // 只支持 MCP
  toolName?: string;
  toolDescription?: string;
  isActive: number;
  callOrder?: number;
  requiredParams?: Record<string, any>;
  optionalParams?: Record<string, any>;
  paramPresets?: Record<string, any>;
  inputSchema?: Record<string, any>;
  createdAt?: string;
  updatedAt?: string;
}

export interface SkillToolBindingReq {
  skillId: number;
  toolCode: string;
  toolId?: number;
  toolSource?: 'mcp'; // 只支持 MCP，默认值
  toolName?: string;
  toolDescription?: string;
  callOrder?: number;
  paramPresets?: Record<string, any>;
}

export interface SkillToolBatchBindingReq {
  skillId: number;
  bindings: SkillToolBindingReq[];
}

export interface SkillToolUnbindReq {
  skillId: number;
  toolCode: string;
}

export interface SkillToolBindingListReq {
  skillId: number;
}

// 可用工具列表响应（仅 MCP Tools）
export interface AvailableToolsVo {
  mcpTools: McpToolVo[];
  totalMcpTools: number;
}

export interface McpToolVo {
  id: number;
  toolName: string;
  displayName?: string;
  description?: string;
  category?: string;
  mcpServerId?: number;
  isGlobal?: number;
  inputSchema?: Record<string, any>;
}

// Skill-Tool 绑定 API
export function bindToolToSkill(params: SkillToolBindingReq): Promise<number> {
  return fetch(
    '/api/config/skill/tool-binding/bind',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function batchBindToolsToSkill(params: SkillToolBatchBindingReq): Promise<void> {
  return fetch(
    '/api/config/skill/tool-binding/batchBind',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function unbindToolFromSkill(params: SkillToolUnbindReq): Promise<void> {
  return fetch(
    '/api/config/skill/tool-binding/unbind',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getSkillToolBindings(skillId: number): Promise<SkillToolBindingVo[]> {
  return fetch(
    '/api/config/skill/tool-binding/list',
    {
      method: 'POST',
      body: JSON.stringify({ skillId }),
    },
    true
  );
}

export function getActiveSkillToolBindings(skillId: number): Promise<SkillToolBindingVo[]> {
  return fetch(`/api/config/skill/tool-binding/active/${skillId}`, { method: 'GET' }, true);
}

export function toggleSkillToolBinding(skillId: number, toolCode: string, isActive: number): Promise<void> {
  return fetch(
    `/api/config/skill/tool-binding/toggle?skillId=${skillId}&toolCode=${toolCode}&isActive=${isActive}`,
    { method: 'POST' },
    true
  );
}

export function getAvailableTools(): Promise<AvailableToolsVo> {
  return fetch('/api/config/skill/tool-binding/available-tools', { method: 'GET' }, true);
}